// extracted by mini-css-extract-plugin
export default {"section":"qjSeC31ZXd1HjGnFbZJd"};